import { ComboboxList as ComboboxList$1 } from '@reach/combobox';
import 'react';
import warning from 'tiny-warning';
import { createComponent } from '../core/create-component.js';
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
const ComboboxList = createComponent({
  displayName: 'ComboboxList',
  root: ComboboxList$1,
  propConfig: {
    classNames: ['swan-combobox-list'],
    processProps(_param) {
      var {
          as,
          component
        } = _param,
        props = _objectWithoutProperties(_param, ["as", "component"]);
      warning(as === undefined && component === undefined, 'props `as` and `component` not supported as ComboboxList uses 3rd party lib');
      return props;
    }
  }
});
export { ComboboxList };